import StockTable from './StockTable';
import { useSearchParams } from 'react-router-dom';
import { useAuthStore } from '../../../store';
import { useFetchData } from '../../../hooks';

import { StockLevelReport } from '../../../types';
import { exportToExcel, roundAndFormat } from '../../../lib/utils';
import StockLevelHeaderFilter from './StockLevelHeaderFilter';

const StockLevelPage = () => {
  const api = '/stock/report/levels';
  const [searchParams] = useSearchParams();
  const { user } = useAuthStore();

  const { data, isLoading } = useFetchData<StockLevelReport[]>(api, {
    locationId: searchParams.get('locationId') || user?.defaultLocation?.id,
    categoryId: searchParams.get('categoryId') || '',
  });

  const handleExport = () => {
    if (data !== undefined) {
      const rows = data.map((row) => ({
        Location: row.locationDescription,
        Product: row.productDescription,
        'Product Code': row.productCode,
        Category: row.categoryDescription,
        UoM: row.uomDescription,
        Quantity: roundAndFormat(row.quantity),
        'Unit Price': roundAndFormat(row.unitPrice),
        'Total Price': roundAndFormat(row.totalPrice),
      }));

      exportToExcel({
        fileName: `stock_level_report`,
        headers: [
          'Location',
          'Product',
          'Product Code',
          'Category',
          'UoM',
          'Quantity',
          'Unit Price',
          'Total Price',
        ],
        data: rows,
      });
    }
  };
  return (
    <>
      <div className={'page-wrapper'}>
        <StockLevelHeaderFilter handleExport={handleExport} />
        <StockTable data={data} isLoading={isLoading} />
      </div>
    </>
  );
};

export default StockLevelPage;
